import { type FeaturedThreadRes } from '@on3/api/src';
import { Link } from '@on3/ui-lib/components/Link';
import { ModuleItem } from '@public/components/MegaBoard/Module/Item';

import styles from './MegaBoardModule.module.scss';

interface MegaboardModuleProps {
  title?: string;
  threads: FeaturedThreadRes[];
}

export const MegaboardModule = ({
  title = 'MegaBoard',
  threads,
}: MegaboardModuleProps) => {
  return (
    <section className={styles.block}>
      <h2>{title}</h2>
      <ul className={styles.list} data-list>
        {threads.map((thread) => (
          <li data-ui="list-item-megaboard" key={thread.threadKey}>
            <ModuleItem {...thread} />
          </li>
        ))}
      </ul>
      <footer className={styles.footer}>
        <Link href="/megaboard">View all megaboard topics</Link>
      </footer>
    </section>
  );
};
